import { network } from 'services/network';

export const getAllTags = () => {
    const url = `api/bo/reporting/getAllTags`;
    return network.post(url).then((response) => {
        return response.data;
    });
};
